import React, { useState, useEffect, useRef } from "react";
import { Image } from 'react-bootstrap';
import FileImage from "../../assets/img/sitelogo.png";
import icon from "../../assets/img/chart/Frame 52.png";
import icon1 from "../../assets/img/chart/Frame 52 (1).png";
import icon2 from "../../assets/img/chart/Frame 52 (2).png";
import Headers from '../header';
import Footer from '../footer/footer';
import DigitalHeader from '../degitallibraryHeader';
import axios from "axios";
import { generateAuthHeader, api_url, API } from "../../util/util";
import { IoIosSend } from "react-icons/io";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

const MarkdownComponents = {
    code({ node, inline, className, children, ...props }) {
        const match = /language-(\w+)/.exec(className || '');
        return !inline && match ? (
            <SyntaxHighlighter
                style={vscDarkPlus}
                language={match[1]}
                PreTag="div"
                {...props}
            >
                {String(children).replace(/\n$/, '')}
            </SyntaxHighlighter>
        ) : (
            <code className={className} {...props}>
                {children}
            </code>
        );
    },
    table({ children }) {
        return (
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    {children}
                </table>
            </div>
        );
    },
    th({ children }) {
        return (
            <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {children}
            </th>
        );
    },
    td({ children }) {
        return (
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {children}
            </td>
        );
    }
};


export const ChatBot = () => {
    const chatMessagesEndRef = useRef(null);
    const [companyName, setCompanyName] = useState("");
    const [permalink, setPermalink] = useState("");
    const [showIntroPanel, setShowIntroPanel] = useState(true);
    const [messages, setMessages] = useState([]);
    const [userInput, setUserInput] = useState("");
    const [hasAskedQuestion, setHasAskedQuestion] = useState(false);
    const getCompanyName = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const permalink = urlParams.get("query");
        setPermalink(permalink);
        const url = `${api_url}/companies/${permalink}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    "Authorization ": generateAuthHeader(),
                },
            });
            console.log(response.data.name);
            if (response.status === 200) {
                setCompanyName(response.data.name);
            } else {
                console.error("Unexpected response");
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    }

    useEffect(() => {
        getCompanyName();
    }, []);
    useEffect(() => {
        // Scroll to the bottom of the chat every time the messages change
        chatMessagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const handleUserInputChange = (e) => {
        setUserInput(e.target.value);
    };



    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    }; 

    const handleSendMessage = async () => {
        if (userInput.trim() === "") return;
    
        // Add user message to the chat
        const newMessages = [...messages, { role: "user", text: userInput }];
        setMessages(newMessages);
    
        // Clear the input field
        setUserInput("");
        setHasAskedQuestion(true);
        try {
            // Make an API call to get the bot's response
            const response = await axios.post(
                `${api_url}/${API.ENDPOINTS.chat}`,
                {
                    company_name: companyName,
                    permalink,
                    messages: newMessages, // Send the updated message history
                },
                {
                    headers: {
                        "Authorization": generateAuthHeader(),
                        "Content-Type": "application/json",
                    },
                }
            );
    
            if (response.status === 200) {
                // Assuming response.data.text contains the bot's message
                const botMessage = response.data.text;
                setMessages((prevMessages) => [
                    ...prevMessages,
                    // { role: "user", text: userInput },
                    { role: "bot", text: botMessage }, // Add bot's message to state
                ]);
            } else {
                console.error("Unexpected response");
            }
        } catch (error) {
            console.error("Error fetching chatbot response:", error);
        }
    };

    return (
        <>
            {/* <DigitalHeader /> */}
            <div className="py-3">
                {!hasAskedQuestion && (
                    <div className="contatent-div">
                        <div className='text-center align-items-center'><Image src={FileImage} /></div>
                       
                        {showIntroPanel && (
                            <div className="grid-container row">
                                <div className="card">
                                    <img className='icon-chtbort' src={icon} alt="Icon" />
                                    <p>What core technologies does this startup leverage for its product or service?</p>
                                </div>
                                <div className="card">
                                    <img className='icon-chtbort' src={icon1} alt="Icon" />
                                    <p>How scalable is the startup’s technology stack?</p>
                                </div>
                                <div className="card">
                                    <img className='icon-chtbort' src={icon2} alt="Icon" />
                                    <p>What innovative features set this startup’s technology apart from its competitors?</p>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <div className={`chat-container ${hasAskedQuestion ? 'expanded' : ''}`}>
                    <div className="chat-messages">
                        {messages.map((message, index) => (
                            <div key={index} className={`chat-message ${message.role}`}>
                                {message.role === 'user' ? (
                                    <p>{message.text}</p>
                                ) : (
                                    <div className="markdown-content">
                                        <svg aria-hidden="true" aria-label="Answer logo" fill="rgba(115, 118, 225, 1)" class="___12fm75w f1w7gpdv fez10in fg4l7m0" role="img" width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><path d="M10.06 18.7a1.63 1.63 0 0 0 2.43-.67l.77-2.34a3.82 3.82 0 0 1 2.42-2.42l2.23-.73a1.61 1.61 0 0 0 1.07-1.3 1.62 1.62 0 0 0-1.13-1.78l-2.21-.72a3.82 3.82 0 0 1-2.42-2.42l-.73-2.23a1.62 1.62 0 0 0-3.07.01l-.74 2.27a3.82 3.82 0 0 1-2.36 2.36l-2.24.73a1.63 1.63 0 0 0 .02 3.07l2.22.72a3.86 3.86 0 0 1 2.42 2.43l.73 2.23c.1.32.32.6.6.8Zm9.74 6.08a1.2 1.2 0 0 0 1.84-.6l.37-1.14a1.6 1.6 0 0 1 1.02-1.02l1.16-.38a1.21 1.21 0 0 0 .59-1.83 1.23 1.23 0 0 0-.62-.45L23 18.99A1.6 1.6 0 0 1 22 17.97l-.38-1.16a1.2 1.2 0 0 0-2.27.01l-.38 1.15a1.6 1.6 0 0 1-.99 1.02l-1.17.38a1.21 1.21 0 0 0-.58 1.83c.15.2.36.36.6.44l1.14.37A1.6 1.6 0 0 1 19 23.04l.37 1.16c.09.24.24.44.44.58Z" fill="rgba(115, 118, 225, 1)"></path></svg> 
                                        {message.loading ? (
                                            <p className="loading-text">
                                                Generating answer<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span>
                                            </p>
                                        ) : (
                                            <ReactMarkdown
                                                remarkPlugins={[remarkGfm]}
                                                components={MarkdownComponents}
                                            >
                                                {message.text}
                                            </ReactMarkdown>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                        <div ref={chatMessagesEndRef}></div>
                    </div>
                    <div className="chat-input">
                        <textarea
                           
                            value={userInput}
                            rows={3}
                            onChange={handleUserInputChange}
                            onKeyPress={handleKeyPress}
                            placeholder="Type a new question (e.g.Type a new question (e.g. what is the difference between Quantexa and Sayari Labs?)"
                        />
                        <button onClick={handleSendMessage}>
                            <IoIosSend />
                        </button>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
